import { InMemoryLeadsRepository } from "../../../../../test/repositories/inMemoryLeadsRepository"
import { makeLead } from "../../../../../test/factories/makeLead"
import { IFetchManyLeadsProtocol } from "../../protocols/leads/IFetchManyLeadsProtocol"
import { FetchManyLeadsUseCase } from "./fetchManyLeads"

let sut: IFetchManyLeadsProtocol
let repository: InMemoryLeadsRepository

describe('Fetch Many Leads', () => {
  beforeEach(()=>{
    repository = new InMemoryLeadsRepository()
    sut = new FetchManyLeadsUseCase(repository)
  })

  it('Should be able to fetch many leads', async ()=> {
    const lead1OnDatabase = makeLead()
    const lead2OnDatabase = makeLead()
    const lead3OnDatabase = makeLead()

    await Promise.all([
      repository.create(lead1OnDatabase),
      repository.create(lead2OnDatabase),
      repository.create(lead3OnDatabase),
    ])

    const {leads} = await sut.execute({})

    expect(leads.length).toEqual(3)
  })
})